import React, { useState } from 'react';
import {
  DEFAULT_PREFERENCES,
  APPOINTMENT_DURATION_OPTIONS
} from '../../utils/settingsConstants';

const DURATION_STORAGE_KEY = 'pestcrm_default_appointment_duration';

const getStoredDuration = () => {
  try {
    const stored = localStorage.getItem(DURATION_STORAGE_KEY);
    if (stored) return parseInt(stored, 10);
  } catch (e) { /* ignore */ }
  return DEFAULT_PREFERENCES.defaultAppointmentDuration;
};

/**
 * General settings tab component
 * Shows user/company information and appointment preferences
 */
const GeneralTab = ({ userProfile }) => {
  const [duration, setDuration] = useState(getStoredDuration);

  const handleDurationChange = (e) => {
    const val = parseInt(e.target.value, 10);
    setDuration(val);
    try {
      localStorage.setItem(DURATION_STORAGE_KEY, String(val));
    } catch (e) { /* ignore */ }
  };

  // Build formatted address from profile fields
  const addressParts = [
    userProfile?.addressLine1,
    userProfile?.addressLine2,
    userProfile?.addressCity,
    userProfile?.addressCounty,
    userProfile?.addressPostcode
  ].filter(Boolean);
  const fullAddress = addressParts.join(', ');

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Company Information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Company Name
            </label>
            <input
              type="text"
              value={userProfile?.companyName || ''}
              readOnly
              className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Contact Email
            </label>
            <input
              type="email"
              value={userProfile?.email || ''}
              readOnly
              className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Phone Number
            </label>
            <input
              type="text" inputMode="tel"
              value={userProfile?.phone || ''}
              readOnly
              className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Mobile
            </label>
            <input
              type="text" inputMode="tel"
              value={userProfile?.mobile || ''}
              readOnly
              className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Address
            </label>
            <input
              type="text"
              value={fullAddress}
              readOnly
              className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>
        </div>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Preferences</h3>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-gray-900">Default Appointment Duration</p>
              <p className="text-sm text-gray-600">Set the default duration for new appointments</p>
            </div>
            <select
              value={duration}
              onChange={handleDurationChange}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pest-blue focus:border-transparent"
            >
              {APPOINTMENT_DURATION_OPTIONS.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralTab;
